import gql from 'graphql-tag'

export const GET_VOIP_TOKEN = gql`
  query GetVoipToken($filter: GetVoipTokenInput) {
    getVoipToken(filter: $filter) {
      isSuccessful
      message
      status
      getVoipToken {
        token
      }
    }
  }
`
